const ALL_GROUPS = [
  {
    id: "track",
    label: "Track",
    items: [
      { path: "/tracking", label: "Tracking" },
      { path: "/growth", label: "Growth" },
      { path: "/health", label: "Health" },
      { path: "/events", label: "Events" },
      { path: "/reminders", label: "Reminders" },
    ],
  },
  {
    id: "insights",
    label: "Insights",
    items: [
      { path: "/milestones", label: "Milestones" },
      { path: "/reports", label: "Reports" },
      { path: "/sleep-analytics", label: "Sleep Analytics" },
    ],
  },
  {
    id: "family",
    label: "Family",
    items: [
      { path: "/sharing", label: "Sharing" },
      { path: "/child-profile", label: "Child Profile" },
      { path: "/resources", label: "Resources" },
      { path: "/profile", label: "Profile" },
    ],
  },
];

const RESTRICTED_PATHS = new Set(["/dashboard", "/resources"]);

const UNAUTH_LINKS = [
  { path: "/login", label: "Sign In", variant: "ghost" },
  { path: "/register", label: "Get Started", variant: "primary" },
];

function filterGroupsForNonOnboarded(groups) {
  return groups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => RESTRICTED_PATHS.has(item.path)),
    }))
    .filter((group) => group.items.length > 0);
}

export function useNavRoutes(user, onboardingCompleted) {
  if (!user) {
    return { groups: [], dashboardLink: null, unauthLinks: UNAUTH_LINKS };
  }

  if (!onboardingCompleted) {
    const restrictedGroups = filterGroupsForNonOnboarded(ALL_GROUPS);
    return {
      groups: restrictedGroups,
      dashboardLink: { path: "/dashboard", label: "Dashboard" },
      unauthLinks: [],
    };
  }

  return {
    groups: ALL_GROUPS,
    dashboardLink: { path: "/dashboard", label: "Dashboard" },
    unauthLinks: [],
  };
}
